import { useState, useEffect } from 'react';

export let openErrorBoundary = () => {};

export const useComponentDidCatch = (
  defaultValue?: boolean,
): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
  const [hasError, setHasError] = useState(defaultValue || false);

  useEffect(() => {
    const originalErrorHandler = window.onerror;

    const errorHandler = (message: any) => {
      if (message === 'Script error.') {
        return;
      }

      setHasError(true);
      if (process.env.NODE_ENV === 'production') {
        console.clear();
      }

      if (originalErrorHandler) {
        console.log(message);
      }
    };

    window.onerror = errorHandler;
    openErrorBoundary = () => {
      setHasError(true);
    };

    return () => {
      openErrorBoundary = () => {};
      window.onerror = originalErrorHandler;
    };
  }, []);

  return [hasError, setHasError];
};
